import { MY_OWN_FILTER, UserType } from '../constants/constants';
import { useUser } from '../context/UserContext';
import { IFilterOption } from '../interface/transaction';
import { useOwnerFilter } from './useOwnerFilter';

export const useMatterRequestOwnerFilter = ({
  isMyOwnDefault,
  restoredValue,
}: {
  isMyOwnDefault: boolean;
  restoredValue?: string | null;
}) => {
  const { user } = useUser();
  const ownerFilter = useOwnerFilter({ isMyOwnDefault, restoredValue });
  const isLocked = user?.userType === UserType.RESTRICTED;
  const value = isLocked ? MY_OWN_FILTER : ownerFilter.value;
  const options = isLocked
    ? ownerFilter.options.filter((option) => option.value === MY_OWN_FILTER)
    : ownerFilter.options;

  return {
    value,
    isLocked,
    options,
    title: ownerFilter.title,
    selectedOptions: options.filter((option) => option.value === value),
    isMyOwn: value === MY_OWN_FILTER,
    // The system already limits a restricted user to their own requests, so the locked filter is
    // only shown, never sent.
    apiFilters: isLocked ? {} : ownerFilter.apiFilters,
    select: (option: IFilterOption) => {
      if (isLocked) return;
      ownerFilter.select(option);
    },
    reset: () => {
      if (isLocked) return;
      ownerFilter.reset();
    },
  };
};
